var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIconAb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9851 17.1799C10.9851 16.5972 11.2166 16.0384 11.6286 15.6264C12.0406 15.2144 12.5994 14.9829 13.1821 14.9829H43.9401C44.5228 14.9829 45.0816 15.2144 45.4936 15.6264C45.9056 16.0384 46.1371 16.5972 46.1371 17.1799V25.9679H10.9851V17.1799Z",
    stroke: "white",
    strokeWidth: 3.7349,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7732 18.2785V11.6875M37.3492 18.2785V11.6875",
    stroke: "white",
    strokeWidth: 3.7349,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9851 25.9678H46.1371V45.7408C46.1371 46.3235 45.9056 46.8823 45.4936 47.2943C45.0816 47.7063 44.5228 47.9378 43.9401 47.9378H13.1821C12.5994 47.9378 12.0406 47.7063 11.6286 47.2943C11.2166 46.8823 10.9851 46.3235 10.9851 45.7408V25.9678Z",
    stroke: "white",
    strokeWidth: 3.7349,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconAb);
export default __webpack_public_path__ + "static/media/calendarIcon_ab.1d69f5e108eae1068c8b95d5334b7961.svg";
export { ForwardRef as ReactComponent };